import { render, staticRenderFns } from "./Subcategoria.vue?vue&type=template&id=40d48b4b&lang=pug"
import script from "./Subcategoria.vue?vue&type=script&lang=js"
export * from "./Subcategoria.vue?vue&type=script&lang=js"
import style0 from "./Subcategoria.vue?vue&type=style&index=0&id=40d48b4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports